<template>
  <div id="map-test">
    <div class="closing" v-if="isPhone">
      <!-- <span>
        <button class="close-btn-modal" @click="$emit('close')"></button>
      </span> -->
      <span class="close-button" @click="$emit('close')">
        <i class="fas fa-times"></i>
      </span>
    </div>
    <!-- Lodging Count Box -->
    <div v-if="isPhone" class="lodging-count-box" :class="{ 'hide-box': scrollingDown }">
      {{ markers.length }} hébergements
    </div>
    <mapbox
        access-token="pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w"
        :map-options="{
        style: isMobileDevice || showV10 ? 'mapbox://styles/mapbox/streets-v10' : 'mapbox://styles/mapbox/streets-v11',
        zoom: 6,
        center: [2.2137, 46.2276],
        dragRotate: !isMobileDevice,
        touchZoomRotate: isMobileDevice ? false : true,
        pitchWithRotate: false,
        dragPan: true,
        scrollZoom: true,
        doubleClickZoom: true,
        touchZoomRotate: true
      }"
        @map-init="displayMarkers"
    />
    <Cardmap v-if="selectedMarker" :lodging="selectedLodging" @unselect="unselectCardMap" :idMarker="selectedMarker" :position="cardPosition" />
    <SimpleCardmap v-if="hoveredMarker && hoveredLodging && !selectedMarker && !isPhone" :lodging="hoveredLodging" :position="hoverCardPosition" @card-hover="handleCardHover" />
  </div>
</template>

<script>
import Mapbox from 'mapbox-gl-vue';
import Cardmap from '../components/cards/Cardmap.vue';
import SimpleCardmap from '../components/cards/SimpleCardmap.vue';
import MapboxLanguage from '@mapbox/mapbox-gl-language';


export default {
  name: 'map-test',
  props: ['markers', 'lodgings', 'selectCardMap', 'selectedMarkerId', 'hoveredLodgingId', 'showV10'],
  components: { Mapbox, Cardmap, SimpleCardmap },
  data() {
    return {
      selectedMarker: null,
      selectedLodging: null,
      hoveredMarker: null,
      hoveredLodging: null,
      hoverTimeout: null,
      showCard: false,
      cardLocked: false,
      cardHovered: false,
      scrollingDown: false,
      lastScrollY: 0,
      boxHidden: false,
      mapInstance: null,
      previousBounds: null,
      previousRegionMarkers: [],
      previousMapState: null, // Store previous zoom and center
      cardPosition: 'right',
      hoverCardPosition: { x: 0, y: 0 },
      isPhone: window.innerWidth <= 600,
      isProgrammaticClick: false, // Flag to track programmatic clicks
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    const observer = new IntersectionObserver(([entry]) => {
      this.boxHidden = entry.intersectionRatio === 0;
    }, {
      root: null,
      threshold: 0.01
    });

    if (Array.isArray(this.lodgings)) {
      this.lodgings.forEach(l => {
        console.log('[DEBUG] Lodging:', l);
        console.log(`ID: ${l.id}, Type: ${l.type ?? '[missing]'}`);
      });
    } else {
      console.warn('[WARN] lodgings is not an array:', this.lodgings);
    }

    if (this.$refs.lodgingCount) {
      observer.observe(this.$refs.lodgingCount);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    const mapContainer = document.getElementById('map-test');
    if (mapContainer) {
      if (this.wheelHandler) {
        mapContainer.removeEventListener('wheel', this.wheelHandler, { passive: false });
      }
      if (this.touchHandler) {
        mapContainer.removeEventListener('touchmove', this.touchHandler, { passive: false });
      }
    }
  },
  methods: {
    handleScroll() {
      const currentScrollY = window.scrollY;
      if (currentScrollY > this.lastScrollY) {
        this.scrollingDown = true;
      } else {
        this.scrollingDown = false;
      }
      this.lastScrollY = currentScrollY;
    },
    disableScrollOutsideMap() {
      const mapContainer = document.getElementById('map-test');

      if (mapContainer) {
        this.wheelHandler = (event) => {
          event.preventDefault();
          event.stopPropagation();
        };
        this.touchHandler = (event) => {
          event.preventDefault();
          event.stopPropagation();
        };
        
        mapContainer.addEventListener('wheel', this.wheelHandler, { passive: false });
        mapContainer.addEventListener('touchmove', this.touchHandler, { passive: false });
      }
    },
    handleMouseEnter() {
      clearTimeout(this.hoverTimeout);
    },
    handleMouseLeave() {
      this.hoverTimeout = setTimeout(() => {
        this.unselectCardMap();
      }, 300); // Delay hiding by 300ms
    },
    handleMarkerHover(markerId, event) {
      clearTimeout(this.hoverTimeout);
      this.hoveredMarker = markerId;
      this.hoveredLodging = this.lodgings.find(
        (lodging) => lodging.id === parseInt(markerId, 10)
      );

      const rect = event.target.getBoundingClientRect();
      const mapContainer = document.getElementById('map-test').getBoundingClientRect();

      const xWithinMap = rect.left - mapContainer.left + rect.width / 2;
      const yWithinMap = rect.top - mapContainer.top + 25;

      const isDesktop = window.innerWidth >= 768;
      const hoverCardWidth = isDesktop ? 380 : 250;
      const hoverCardHeight = isDesktop ? 200 : 160; // Approximate card height
      const padding = 20;

      // Check if showing to the right would overflow the map
      const overflowsRight = xWithinMap + hoverCardWidth + padding > mapContainer.width;

      // Check if showing below would overflow the map
      const overflowsBottom = yWithinMap + hoverCardHeight + padding > mapContainer.height;

      // Compute X position
      const xPosition = overflowsRight
        ? (xWithinMap - hoverCardWidth - padding) + 150
        : xWithinMap + padding;

      // Compute Y position - if overflows bottom, show above the marker
      const yPosition = overflowsBottom
        ? yWithinMap - hoverCardHeight - 30 // Show above marker with some spacing
        : yWithinMap;

      this.hoverCardPosition = {
        x: xPosition,
        y: yPosition
      };
    },
    handleMarkerLeave() {
      this.hoverTimeout = setTimeout(() => {
        if (!this.cardHovered) {
          this.hoveredMarker = null;
          this.hoveredLodging = null;
        }
      }, 200); // Small delay to prevent flickering
    },
    handleCardHover(isHovering) {
      this.cardHovered = isHovering;
      if (isHovering) {
        clearTimeout(this.hoverTimeout);
      } else {
        this.hoverTimeout = setTimeout(() => {
          this.hoveredMarker = null;
          this.hoveredLodging = null;
        }, 200);
      }
    },
    displayOneMarker(map, mk) {
      const marker = new mapboxgl.Marker()
          .setLngLat(mk)
          .addTo(map);
    },
    displayMarkers(map) {
      if (!map) return;
      
      this.mapInstance = map;
      
      // Add a unique identifier to distinguish this map from Mapfind
      if (map._container) {
        map._container.setAttribute('data-map-type', 'maptest');
      }

      map.addControl(new MapboxLanguage({
        defaultLanguage: 'fr'
      }));
      
      // Clear existing markers before adding new ones
      const existingMarkers = document.querySelectorAll('[data-map-type="maptest"] .mapboxgl-marker');
      existingMarkers.forEach(marker => marker.remove());
      
      this.markers.forEach((marker, index) => {
        let el = document.createElement('div');
        el.id = marker[2];
        const priceLabel = document.createElement('div');
        priceLabel.textContent = `${marker[3]}€`;
        priceLabel.classList.add('price-label', 'green-label');
        priceLabel.setAttribute('data-lodging-id', marker[2]);

        el.appendChild(priceLabel);

        // Hover effect to enlarge marker and show simple card
        priceLabel.addEventListener('mouseenter', (event) => {
          priceLabel.classList.add('hovered');
          if (!this.cardLocked) {
            this.handleMarkerHover(marker[2], event);
          }
        });

        priceLabel.addEventListener('mouseleave', () => {
          priceLabel.classList.remove('hovered');
          if (!this.cardLocked) {
            this.handleMarkerLeave();
          }
        });

        el.addEventListener('click', () => {
          // Find lodging
          const selectedLodging = this.lodgings.find(
            (l) => l.id === parseInt(el.id)
          );

          if (this.isPhone || this.isProgrammaticClick) {
            this.cardLocked = true;
            
            // Save current map state before changing it
            if (!this.isProgrammaticClick) {
              // For user clicks, save the current state
              this.previousMapState = {
                center: map.getCenter(),
                zoom: map.getZoom()
              };
            } else {
              // For programmatic clicks, set state to show all markers
              this.previousMapState = {
                center: [2.2137, 46.2276], // Center of France
                zoom: 6 // Zoom level to see all markers
              };
            }
            this.selectMarker(el.id);

            // Apply black label on click too
            priceLabel.classList.remove('green-label');
            priceLabel.classList.add('black-label');

            // Save markers in the same region only if not programmatic click
            if (!this.isProgrammaticClick && selectedLodging?.region?.name) {
              this.previousRegionMarkers = this.markers.filter((m) => {
                const lodging = this.lodgings.find((l) => l.id === parseInt(m[2]));
                return lodging?.region?.name === selectedLodging.region.name;
              });
            }
            
            map.flyTo({
              center: [marker[0], marker[1]],
              zoom: 14,
              offset: [0, 10]
            });
            
            // Reset the flag after processing
            this.isProgrammaticClick = false;
          } else {
            if (selectedLodging && selectedLodging.slug) {
              window.open(`/reservation-hotel/${selectedLodging.slug}`, '_blank');
            }
          }
        });
        
        new mapboxgl.Marker(el)
            .setLngLat([marker[0], marker[1]])
            .addTo(map);
      });

      // Set default view to France after adding markers
      // this.fitMapToMarkers(map, this.markers);
    },
  //   fitMapToMarkers(map, markers) {
  //     const bounds = new mapboxgl.LngLatBounds();
  //     markers.forEach(marker => bounds.extend([marker[0], marker[1]]));
  //     map.fitBounds(bounds, { padding: 50, duration: 1000, maxZoom: 15 });
  // setTimeout(() => {
  //   if (map.getZoom() < 14) {
  //     map.setZoom(5);
  //   }
  // }, 1200);
  //   },
    fitMapToMarkers(map, markers) {
      // Set default view to France
      map.flyTo({
        center: [2.2137, 46.2276], // Center of France
        zoom: 6, // Good zoom level to see France
        duration: 1000
      });
    },
    selectMarker(markerId) {
    this.selectedMarker = markerId;
    this.selectedLodging = this.lodgings.find(
      (lodging) => lodging.id === parseInt(markerId, 10)
    );
    this.showCard = true;
  },
    unselectCardMap() {
      this.selectedMarker = null;
      this.selectedLodging = null;
      this.hoveredMarker = null;
      this.hoveredLodging = null;
      this.showCard = false;
      this.cardLocked = false;
      
      // Reset all price labels to green
      document.querySelectorAll('.price-label').forEach(label => {
        label.classList.remove('black-label');
        label.classList.add('green-label');
      });
      
      // Restore previous map state (zoom and center)
      if (this.mapInstance && this.previousMapState) {
        this.mapInstance.flyTo({
          center: this.previousMapState.center,
          zoom: this.previousMapState.zoom,
          duration: 800
        });
        this.previousMapState = null; // Clear saved state
      } else if (this.mapInstance && this.previousRegionMarkers.length > 0) {
        // Fallback to region bounds if no previous state saved
        const bounds = new mapboxgl.LngLatBounds();

        this.previousRegionMarkers.forEach((marker) => {
          bounds.extend([marker[0], marker[1]]);
        });

        this.mapInstance.fitBounds(bounds, {
          padding: 50,
          duration: 800,
          maxZoom: 12
        });
      }
    },
    updateMarkerColor(lodgingId, isHovered) {
      const priceLabel = document.querySelector(`[data-lodging-id="${lodgingId}"]`);
      if (priceLabel) {
        if (isHovered) {
          priceLabel.classList.remove('green-label');
          priceLabel.classList.add('black-label');
        } else {
          priceLabel.classList.remove('black-label');
          priceLabel.classList.add('green-label');
        }
      }
    },
    focusOnLodging(lodgingId) {
      // Find the marker element for this lodging
      const markerElement = document.querySelector(`[data-lodging-id="${lodgingId}"]`);
      if (markerElement) {
        // Set flag to indicate this is a programmatic click
        this.isProgrammaticClick = true;
        
        // Simulate a click on the marker to show the CardMap
        markerElement.click();
        
        // Also fly to the marker location if map instance exists
        if (this.mapInstance) {
          const marker = this.markers.find(m => m[2] === parseInt(lodgingId));
          if (marker) {
            this.mapInstance.flyTo({
              center: [marker[0], marker[1]],
              zoom: 14,
              offset: [0, 10]
            });
          }
        }
      }
    }
  },
  watch: {
    hoveredLodgingId(newId, oldId) {
      // Reset previous hovered marker
      if (oldId) {
        this.updateMarkerColor(oldId, false);
      }
      // Set new hovered marker
      if (newId) {
        this.updateMarkerColor(newId, true);
      }
    },
    markers(newMarkers) {
      this.$nextTick(() => {
        if (this.mapInstance) {
          this.displayMarkers(this.mapInstance);
        }
      });
    },
    lodgings(newLodgings) {
      this.$nextTick(() => {
        if (this.mapInstance) {
          this.displayMarkers(this.mapInstance);
        }
      });
    },
  },
  computed: {
    isMobileDevice() {
      return window.innerWidth <= 600;
    }
  }
}
</script>

<style lang="scss" rel="stylesheet">
@import "app/assets/stylesheets/components/map.scss";
@import 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css';


.map-sticky-active {
  #map-test {
    height: calc(100vh - 40px) !important;
  }
}
#map-test {
  width: 100%;
  
  .mapboxgl-map {
    width: 100% !important;
    height: 100% !important;
  }
  
  .mapboxgl-canvas {
    width: 100% !important;
    height: 100% !important;
  }
}

.marker {
  background-image: none !important;
  background-color: transparent;
  border: none;
  position: relative;
}

.price-label {
  background: #3b6152;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  transition: transform 0.2s ease, font-size 0.2s ease;
  pointer-events: auto;
  touch-action: none;
  user-select: none;
  cursor: pointer;

  &.hovered {
    z-index: 1000;
  }

  &.black-label {
    background-color: black;
  }
}

.price-label.green-label {
  background-color: #3b6152;
  height: fit-content;
}

.price-label.black-label {
  background-color: #000;
  height: fit-content;
}
.green-label {
  background-color: #3b6152; // green
}

.black-label {
  background-color: #000000; // black
}
.lodging-count-box {
  position: absolute;
  top: 3rem;
  left: 20px;
  background: white;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.hide-box {
  opacity: 0;
  transform: translateY(-20px);
  pointer-events: none;
}

#card-map {
  position: absolute;
  top: 10%;
  left: 10%;
  width: 40%;
  z-index: 1000;
  background: white;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

@media screen and (min-width: 700px) {
  
  #map-test #map {
    height: 100vh !important;
    margin-bottom: 0 !important;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  #map-test {
    height: 100vh !important;
  }

  #card-map {
    position: fixed;
    top: 10%;
    left: 10%;
    width: 80% !important;
    z-index: 1000;
    background: white;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  .closing{
    background: white;
    padding: 10px 5px;
    margin-bottom: 0!important;
  }
  .mapboxgl-canvas {
    height: 100vh !important;
  }
  #map-test #map {
    height: 100vh !important;
  }
}

@media only screen and (max-width: 600px) {
  .price-label:hover {
    cursor: default;
  }
}

@media only screen and (max-device-width: 480px) {
  #map-test {
    height: 100vh !important;
    z-index: 1000;
  }
  .close-btn-modal{
    height: 20px;
    width: 20px;
  }
  #card-map {
    position: fixed;
    top: 10%;
    left: 10%;
    width: 80% !important;
    z-index: 1000;
    background: white;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  .mapboxgl-canvas {
    height: 95vh !important;
    width: 100% !important;

  }
  .modal-header{
    display: none !important;
  }
  #map-test #map {
    height: 100vh !important;
  }
  .mapboxgl-map{
    width: 100% !important;
  }
  #map-test #map{
    width: 100% !important;
  }
}
// @media only screen and (max-width: 600px) { 
//   //html, body {
//   //  overflow: hidden;
//   //  height: 100vh;
//   //}

//   #map-test {
//     position: absolute;
//     width: 100%;
//     height: 100vh;
//     top: 0;
//     left: 0;
//   }

  .mapboxgl-map {
    width: 100%;
    height: 100vh;
    touch-action: pan-x pan-y;
  }

.close-button {
width: 36px;
height: 36px;
background: #ddd;
border-radius: 8px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
}

.price-label {
  background-color: #3B6152;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  color: white;
  position: absolute;
  top: -25px;
  left: -50px;
}


</style>

<!--<style lang="scss" rel="stylesheet">-->
<!--@import "app/assets/stylesheets/components/map.scss";-->
<!--</style>-->

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  #map-test {  
    margin-bottom: 0;
  }
}
</style>